var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{class:_vm.footerClass,attrs:{"absolute":"","color":"secondary"}},[_c('div',{staticClass:"text-center w100"},[_c('router-link',{attrs:{"to":"/disclaimer"}},[_vm._v("Disclaimer")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }